import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle } from 'recompose';
import { fetchCustomer } from '../store/actions/customers';
import { openExportDialog, closeExportDialog, cancelExportDialog } from '../store/actions/fileexport';
import { fetchFilteredBranches } from '../store/actions/branches'
import Customer from '../components/customer';
import { withLoadingComponent, withErrorComponent } from '../components/loading';

const mapStateToProps = (state, ownProps) => {
    return {
        mobile: state.browser.lessThan.medium,
        ...state.customer,
        showWarnings: ()=> {
            ownProps.history.push(`/customers/${state.customer.customer.id}/status`)
        },
        showMap: ()=> {
            ownProps.history.push(`/customers/${state.customer.customer.id}/map`)
        },
        exportDialog: {...state.fileexport},
    };

};

const mapDispatchToProps = (dispatch, ownProps) => {
    const customerId = ownProps.match.params.customerId;
    return {
        fetchCustomer: () => dispatch(fetchCustomer(customerId)),
        openExportDialog: () => dispatch(openExportDialog()),
        closeExportDialog: (range) => dispatch(closeExportDialog(range)),
        cancelExportDialog: () => dispatch(cancelExportDialog()),
        fetchFilteredBranches: (key)=> dispatch(fetchFilteredBranches(customerId, key))
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchCustomer();
    }
};

export default compose(
        withRouter,
        connect(mapStateToProps, mapDispatchToProps),
        lifecycle(lifecycleValue),
        withErrorComponent,
        withLoadingComponent
    )(Customer);



// WEBPACK FOOTER //
// ./src/containers/CustomerContainer.js